import React, { useId } from "react";
export function ContentSearch({ value, onChange, label }) {
  const id = useId();
  return <div className="mb-4">
    <label htmlFor={id} className="block text-sm font-medium">{label}</label>
    <div className="mt-2 flex gap-2"><input id={id} type="search" value={value} onChange={(event) => onChange(event.target.value)} className="min-h-11 min-w-0 flex-1 rounded-xl border border-border bg-background px-3 text-base" />
      {value && <button type="button" onClick={() => onChange("")} className="min-h-11 rounded-xl border px-3 text-sm">Tyhjennä</button>}</div>
    <p className="mt-1 text-xs text-muted-foreground">Etsii vain tähän näkymään ladatuista tiedoista.</p>
  </div>;
}
